import {Component} from '@angular/core';

@Component({
    selector: `app-horizontal-loader`,
    templateUrl: './horizontal-loader.html',
    styleUrls: ['./horizontal-loader.css']
})
export class HorizontalLoaderComponent {
}